import { render, staticRenderFns } from "./ProductCreate.vue?vue&type=template&id=24ac7116&"
import script from "./ProductCreate.vue?vue&type=script&lang=js&"
export * from "./ProductCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports